
import React from "react";
import { Link } from "react-router-dom";

const Excellence = () => {
  return (
    <section className="w-full bg-white px-4 flex justify-center pt-10 pb-20 md:py-20">
      <div className="max-w-7xl w-full flex flex-col lg:flex-row items-center gap-12 px-12">
        {/* Left: Video instead of Image */}
        <div className="w-full lg:w-1/2">
          <video
            src="/videos/milestone.mp4"
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-auto rounded-lg shadow-lg object-cover"
          
          />
        </div>

        {/* Right: Text */}
        <div className="w-full lg:w-1/2">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
            Pioneering Excellence in MEP <br /> Solutions
          </h2>
          <div className="w-16 h-1 bg-red-600 my-4 rounded"></div>
          <p className="text-gray-700 text-base md:text-lg mb-4 leading-relaxed">
            At Milestone Associates, we cherish the dreams and visions of our clients,
            treating each project as a unique canvas to paint our innovation on.
            We are not just consultants; we are your partners in building a
            future that resonates with quality, reliability, and excellence.
            Journey with us as we redefine what's possible in the MEP sector,
            creating spaces that embody innovation and technical finesse.
          </p>
          <p className="text-gray-700 text-base md:text-lg mb-8 leading-relaxed">
            Our ethos is rooted in the relentless pursuit of perfection, where
            each project is an opportunity to showcase our mastery in MEP
            services. We believe in fostering strong partnerships with our
            clients, where your dreams become the blueprint of our endeavors.
          </p>
          <Link to="/about" className="px-6 py-3 border border-black text-black font-medium hover:bg-black hover:text-white transition rounded no-underline">
            Discover Our Journey
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Excellence;
